import type { SaleskoOAuthProvider } from "@salesko/contracts";
import { Apple, Linkedin, UserRound, type LucideIcon } from "lucide-react";
import { GoogleGlyph } from "../../components/GoogleGlyph";
import { useI18n } from "../../i18n";

const authProviderMeta = {
  google: { icon: UserRound, label: "Google" },
  apple: { icon: Apple, label: "Apple" },
  linkedin: { icon: Linkedin, label: "LinkedIn" }
} satisfies Record<SaleskoOAuthProvider, { icon: LucideIcon; label: string }>;

type AuthProviderButtonsProps = {
  ariaLabel?: string;
  availableAuthProviders: SaleskoOAuthProvider[];
  buttonClassName?: string;
  className?: string;
  onSignIn: (provider: SaleskoOAuthProvider) => void;
};

export function AuthProviderButtons({
  ariaLabel,
  availableAuthProviders,
  buttonClassName = "secondary-button agent-auth-button",
  className = "agent-auth-providers",
  onSignIn
}: AuthProviderButtonsProps) {
  const { t } = useI18n();
  if (availableAuthProviders.length === 0) {
    return null;
  }

  return (
    <div className={className} aria-label={ariaLabel ?? t.authProviders.signInOptions}>
      {availableAuthProviders.map((provider) => {
        const providerMeta = authProviderMeta[provider];
        const ProviderIcon = providerMeta.icon;
        return (
          <button
            type="button"
            key={provider}
            className={buttonClassName}
            onClick={() => onSignIn(provider)}
            title={t.common.signInWith(providerMeta.label)}
          >
            {provider === "google" ? <GoogleGlyph size={16} /> : <ProviderIcon size={16} />}
            <span>{providerMeta.label}</span>
          </button>
        );
      })}
    </div>
  );
}
